// extracted by mini-css-extract-plugin
export default {"navLink":"SearchNavLink_navLink__da3Zg","glassWrapper":"SearchNavLink_glassWrapper__3ylso"};